import { Utility, utility_controller } from '../utility/utility_controller'

var $sm_element

var onResize = function () {
	if (typeof $sm_element != 'undefined') {
		$sm_element.each(function () {
			var $el = jQuery(this)
			var config = $el.data('config')
			initLayoutType($el, config)
		})
	}
}

var initLayoutType = function ($el, config) {
	var screenSize = Utility.screenSize
	var config_part = config[screenSize]
	var w = config_part.width
	var h = config_part.height
	var space_between = config_part.spacebetween
	var w_or_h = config.setwidthorheight
	$el.find('.lay-icon-inner').css({
		paddingLeft: space_between / 2 + 'px',
		paddingRight: space_between / 2 + 'px',
	})
	switch (w_or_h) {
		case 'width':
			$el.find('.lay-icon-inner').css({
				width: w + 'px',
				height: '',
			})
			break
		case 'height':
			$el.find('.lay-icon-inner').css({
				width: '',
				height: h + 'px',
			})
			break
	}
}

var i = function () {
	window.laytheme.on('sizechanged', onResize)
	bindOnNewPageShown()
}

var bindOnNewPageShown = function () {
	window.laytheme.on('newpageshown', function () {
		$sm_element = jQuery('.lay-socialmedia-icons')
		$sm_element.each(function () {
			var $el = jQuery(this)
			var config = $el.data('config')
			initLayoutType($el, config)
			this.classList.add('initialized')
		})
	})
}

var socialmediaicons_controller = {
	i: i,
}

export default socialmediaicons_controller
